import { useGetQuery } from '../../graphql';

export const useIssue = (issueId: string) => {
  const { data, isLoading } = useGetQuery({
    modelName: 'issue',
    query: GET_ISSUE,
    id: issueId,
  });

  return { issue: data, isLoading };
};

const GET_ISSUE = `
    query getIssue($id: ID!) {
      getIssue(id: $id) {
        id
        title
        type
        severity
        isPinned
        workspace {
          id
          name
        }
        asset {
          id
          name
          description
        }
        createdBy {
          id
          name {
            first
            last
          }
        }
        createdAt
        adjustCreationDate
        updatedAt
        routineVersion {
          config
          createdAt
          id
          order
          type
        }
        location {
          type
          coordinates
        }
        # TODO: restore createdFrom once Peter's enum-update PR lands.
        # Temporarily omitted to avoid a backend enum serialization error
        # when the DB stores values not in the IssueCreationSource enum
        # (e.g. "JOHN_DEERE" from legacy test data). See
        # issues/0000_issue-createdfrom-enum-drift-john-deere.md.
        # Peter confirmed (PR #402 review) that the offending test data
        # was cleaned up and the JOHN_DEERE enum value will be added by
        # his PR — remove this workaround after his PR merges.
        createdFromAddress
        labels {
          id
          name
        }
        userMentions {
          id
          name {
            first
            last
          }
        }
        assetRoutine {
          id
          exceptionCount
          data
          routineVersion {
            id
            type
            config
          }
          createdAt
          createdBy {
            id
            name {
              first
              last
            }
          }
          routine {
            id
          }
        }
        onboarding {
          nextIssue
        }
      }
    }
`;
